import styles from './FriendsPage.module.css';
import FriendsHeader from './FriendsHeader/FriendsHeader.tsx';
import NoFriends from './NoFriends/NoFriends.tsx';
import HaveFriends from './HaveFriends/HaveFriends.tsx';
import { useEffect, useState } from 'react';
import { getReferrals } from '../../Requests/referrals/referrals.ts';
import type { WebApp } from '../../types/telegram';
import CustomLoader from '../../components/CustomLoader/CustomLoader';
import NoFriendsV2 from './NoFriendsV2/NoFriendsV2.tsx';
import UserInfoTop from '../../components/UserInfoTop/UserInfoTop.tsx';
// import VectorIcon from '../../assets/friendsIcons/Vector.png'
import CopyButton from './CopyButton/CopyButton.tsx';
import BalanceTop from '../../components/BalanceTop/BalanceTop.tsx';

interface IReferralsData {
  total_collectable: {
    beastcoins: number;
  };
  current_collectable: {
    beastcoins: number;
  };
  referrals: [
    {
      id: number;
      username: string;
      name: string;
      photo_url: string;
      beasts_earned: number;
    },
  ];
  total_referrals_count: number;
}
interface ExtendedWebApp extends WebApp {
  contentSafeAreaInset?: {
    top: number;
    bottom: number;
    left: number;
    right: number;
  };
}

const FriendsPage = () => {
  const [referralsData, setReferralsData] = useState<IReferralsData>();
  const [isLoading, setIsLoading] = useState(true);
  const [isBackgroundLoaded, setIsBackgroundLoaded] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const tg = window.Telegram?.WebApp as ExtendedWebApp;
  useEffect(() => {
    if (!tg) return;

    console.log(window.Telegram?.WebApp.initData);

    const apply = () => {
      const top = tg?.contentSafeAreaInset?.top ?? 0;
      document.documentElement.style.setProperty(
        '--tg-viewport-content-safe-area-inset-top',
        `${top}px`,
      );
    };

    apply();
    tg.onEvent?.('contentSafeAreaChanged', apply);
    return () => tg.offEvent?.('contentSafeAreaChanged', apply);
  }, [tg]);

  const refreshReferrals = async () => {
    setIsLoading(true);
    const initData = window.Telegram?.WebApp.initData;
    if (initData) {
      const data = await getReferrals(initData);
      setReferralsData(data);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    refreshReferrals();
  }, []);

  useEffect(() => {
    console.log('Начинаем загрузку фонового изображения');
    const img = new Image();
    img.onload = () => {
      console.log('Фоновое изображение загружено успешно');
      setIsBackgroundLoaded(true);
    };
    img.onerror = () => {
      console.log('Ошибка загрузки фонового изображения, продолжаем без него');
      setIsBackgroundLoaded(true);
    };

    img.src = '@/assets/backgrounds/FriendsPageBackground.webp';

    const timeout = setTimeout(() => {
      console.log('Таймаут загрузки фонового изображения');
      setIsBackgroundLoaded(true);
    }, 10000);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  const isAllLoaded = isBackgroundLoaded && !isLoading;

  useEffect(() => {
    if (!isAllLoaded) {
      const timer = setTimeout(() => {
        setShowLoader(true);
      }, 1000);
      return () => clearTimeout(timer);
    } else {
      setShowLoader(false);
    }
  }, [isAllLoaded]);

  return (
    <div className={styles.container}>
      {/* <FriendsHeader /> */}

      <div className={styles.container__contentContainer}>
        {!isAllLoaded && (
          <div className={styles.container__loaderContainer}>
            <CustomLoader />
          </div>
        )}

        <div style={{ visibility: isAllLoaded ? 'visible' : 'hidden' }}>
          <BalanceTop />
          <UserInfoTop />
          <div className={styles.inventoryBanner}>
            <div className={styles.inventoryBanner__gradientOverlay}></div>
            <div className={styles.inventoryBanner__text}>
              <div className={styles.inventoryBanner__header}>
                Friends
              </div>
              <div className={styles.inventoryBanner__p}>
                Приглашай друзей и <br /> получай бонусные спины
              </div>
            </div>
            <div className={styles.inventoryBanner__icons}>
              {/* <div className={styles.inventoryBanner__vector}><VectorIcon /></div> */}
              <div className={styles.inventoryBanner__background}></div>
            </div>
          </div>
          <div className={styles.friendsBlock__container}>
            <div className={styles.friendsBlock}>
              <div className={styles.friendsBlock__info}>
                <div className={styles.friendsBlock__iconFriends}></div>
                <div className={styles.friendsBlock__number}>
                  36
                </div>
              </div>
              <div className={styles.friendsBlock__text}>
                Приглашенных друзей
              </div>
            </div>
            <div className={styles.friendsBlock}>
              <div className={styles.friendsBlock__info}>
                <div className={styles.friendsBlock__iconSpin}></div>
                <div className={styles.friendsBlock__number}>
                  1280
                </div>
              </div>
              <div className={styles.friendsBlock__text}>
                Полученных спинов
              </div>
            </div>
          </div>
          <CopyButton />
          <NoFriendsV2/>
          {/* {referralsData?.referrals && referralsData.referrals.length > 0 ? (
            <HaveFriends
              {...referralsData}
              refreshReferrals={refreshReferrals}
            />
          ) : (
            <NoFriendsV2 />
          )} */}
        </div>
      </div>
    </div>
  );
};

export default FriendsPage;
